import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions.js';
import mutations from './mutations.js';
Vue.use(Vuex);
// 这里为全局的，模块内的请在模块内动态注册
const store = new Vuex.Store({
    strict: true,
    state: {
        token:'',
        onMessageArrived:null,
        todayDev:[],
        AlarmNum:'',  //今日实时报警数
        onlineNum:'',   //今日实时上下线数
        storeTest:{
            name1:'',
            name2:''
        },
        clients:{},
        AMapData: {
            zoom: '',//当前地图缩放值
            pitch: '',
            status: '',//记录地图当前状态 省province  市city  单位company
        },
        redrawPage:null,
        map_config:[

        ],
        map_other:[

        ],
        Echartmap_config:{},
        //民品设备占比图表数据
        floorDeviceData:[

        ],
        //民品开阀数实时状态
        valveOpen:0,
        //地图类型
        map_type:null

    },
    getters: {},
    mutations,
    actions
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js